module.exports = __webpack_public_path__ + "img/ic_format_list_roman_numerals.c5dcd132.svg";